<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Branch
            </template>
            <template v-slot:pageDetail>
                List
            </template>
        </o-bread-crumb>
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">List of Branches</a>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm" v-if="write">
                        <router-link :to="{ name: 'BranchForm' }" class="nav-link text-white">Add new branches
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="" v-if="page.output">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">                                
                            <o-search :searchOptions="searchOptions" :statusOptions="statusOptions" @submit="search" @clear="clearSearch"></o-search>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm">
                        <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                    </li>
                </ul> 
                <o-table style="text-align:left;" class="table-hover">
                    <thead>
                        <tr>
                            <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in branches" :key="index" :class="{ 'blur-row': item.deleted_at }">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td :class="item.deleted_at ? 'status-inactive' : 'status-active'">
                                {{ item.deleted_at ? 'Inactive' : 'Active' }}
                            </td>
                            <td>{{ item.code }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.business_profile.address }}</td>
                            <td>{{ item.business_profile.phone }}</td>
                            <td>{{ item.business_profile.id }}</td>
                            <td class="ml-3">
                                <div class="d-flex">
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-info rounded-pill text-white" v-if="write">
                                            <router-link class="text-white" :to="{ name: 'BranchEdit', params: { id: item.id } }">Edit
                                            </router-link>
                                        </button>
                                    </div>
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-deactivate-custom rounded-pill text-white" v-if="write && item.deleted_at == null">
                                            <router-link class="text-white" :to="{ name: 'Branch' }" @click.prevent="deactivate(item.id, index)">Deactivate
                                            </router-link>
                                        </button>
                                        <button class="btn btn-sm btn-activate-custom rounded-pill text-white" v-if="write && item.deleted_at != null">
                                            <router-link class="text-white" :to="{ name: 'Branch' }" @click.prevent="activate(item.id, index)">Activate
                                            </router-link>
                                        </button>
                                    </div>
                                    <div>
                                        <button class="btn btn-sm btn-danger rounded-pill text-white" v-if="write" @click.prevent="confirmDelete(item)">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="branches.length === 0">
                            <td colspan="7" class="text-center">No branches available</td>
                        </tr>
                    </tbody>
                </o-table>
            </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page" :total="meta.total" @callback="navPage"/>
            </div>
            </div>
            
            <o-warning-box
                v-if="isWarningVisible"
                :title="'Error Delete'"
                :message="warningMessage"
                @cancel="closeWarning()"
                :hide-action="true"
            />
            <o-warning-box
                v-if="isDeleteConfirmVisible"
                title="Delete Branch"
                :item-name="itemToDelete?.name || 'this branch'"
                warning-message="This action cannot be undone."
                confirm-text="Yes, Delete"
                cancel-text="Cancel"
                :is-loading="page.isLoading"
                @confirm="handleDelete"
                @cancel="closeDeleteConfirm"
            />
        </div>
    <br>

</template>

<script>
import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OSearch, OWarningBox} from '@/components/OmnihControl'

import { onMounted, reactive, ref, computed, watch, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        let lastActivePage = 1;

        let meta = computed(() => store.state.Branch.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'branch'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    load_state();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                load_state();
            }

            // Check if redirected from create branch page
            if (route.query.newBranch === 'true') {
                store.dispatch('Branch/read').then(() => {
                    const lastPage = meta.value.total;
                    if (lastPage > 1 && meta.value.page !== lastPage) {
                        const newMeta = { ...meta.value, page: lastPage };
                        store.commit('Branch/switch_page', { meta: newMeta });
                        store.dispatch('Branch/read');
                    }
                    router.replace({ name: 'Branch' });
                });
            }
        });

        onBeforeUnmount(() => {
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Branch/switch_page', { meta: updatedMeta });
            
            store.commit('Branch/clear_search');
            store.dispatch('Branch/read').then(() => {});
        });

        let fields = ref([
            'No',
            'Status',
            'Code',
            'Name',
            'Address',
            'Phone',
            'Business Profile',
            'Action'
        ]);

        const thisComponentShow = ref(true);

        const branchSearch = ref([]);

        const selectBranch = ref();
        const validation = ref('');
        const isWarningVisible = ref(false);
        const warningMessage = ref('');

        const searchBy = reactive({
            selected:"code",
            criteria:""
        })

        const searchOptions = reactive([
            { value: 'code', text: 'code' },
            { value: 'name', text: 'name' },
            { value: 'status', text: 'status' },
        ]);

        const statusOptions = reactive([
            { value: 'active', text: 'active' },
            { value: 'inactive', text: 'inactive' },
        ]);

        const write = ref(false);
            
        function load_state(){
            page.isLoading = true;
            
            store.dispatch('Auth/getBusinessProfile').then(businessProfile => {
                
                const filter = {
                    corporate_id: businessProfile.corporate_id
                }

                store.commit('Branch/add_filter', {filter});

                store.dispatch('Branch/read')
                .then(() => {
                    page.isLoading = false;
                    page.output = true;
                })
                .catch((err) => {
                    console.log(err.response)
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                    page.isLoading = false;
                    page.output = true;
                });
                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            });
            
        }

        function deactivate(id) {
            page.isLoading = true;

            if(confirm("Do you really want to deactivate ?")){
                store.dispatch('Branch/deactivate', id)
                .then(() => {
                    load_state()
                }).catch((err) => {
                    console.log(err);
                    validation.value = err.error;
                }).finally(() => {
                    page.isLoading = false;
                });
            }else{
                page.isLoading = false;
            }
        }

        function activate(id) {
            page.isLoading = true;

            if(confirm("Do you really want to activate ?")){
                store.dispatch('Branch/activate', id)
                .then(() => {
                    load_state()
                }).catch((err) => {
                    console.log(err);
                    validation.value = err.error;
                }).finally(() => {
                    page.isLoading = false;
                });
            }else{
                page.isLoading = false;
            }
        }

        const isDeleteConfirmVisible = ref(false)
        const itemToDelete = ref(null)

        const confirmDelete = (item) => {
            isWarningVisible.value = false;
            warningMessage.value = '';
            const msg = 'This branch cannot be deleted because it still has associated merchant. Please remove all merchant or reassign the merchant before deleting this branch.';

            if (item.merchant_count > 0) {
                warningMessage.value = msg;
                isWarningVisible.value = true;
                return;
            }

            itemToDelete.value = item
            isDeleteConfirmVisible.value = true
        }

        const closeDeleteConfirm = () => {
            isDeleteConfirmVisible.value = false
            itemToDelete.value = null
        }

        const handleDelete = () => {
            if (!itemToDelete.value) return

            page.isLoading = true;
            const id = itemToDelete.value.id;

            const currentPage = meta.value.page;
            const currentBranchesCount = store.state.Branch.branches.length;
            
            store.dispatch('Branch/delete', id)
            .then(() => {
                // If deleting the last item on current page and not on page 1
                if (currentBranchesCount === 1 && currentPage > 1) {
                    console.log('Last item on page deleted, moving to previous page');
                    const newPage = currentPage - 1;
                    lastActivePage = newPage;
                    const _meta = {...meta.value, page: newPage};
                    store.commit('Branch/switch_page', {meta: _meta});
                }
                load_state()
            }).catch((err) => {
                console.log(err);  
                const msg = 'This branch cannot be deleted because it still has associated merchant. Please remove all merchant or reassign the merchant before deleting this branch.';
                warningMessage.value = msg;
                isWarningVisible.value = true;
            }).finally(() => {
                page.isLoading = false;
                closeDeleteConfirm();
            });
        }

        function navPage(pageNum){
            lastActivePage = pageNum;
            const _meta = {... meta.value, page: pageNum}
            
            store.commit('Branch/switch_page',{meta:_meta})
            load_state()
        }

        function search(searchBy){
            const {selected, criteria, status} = searchBy;

            if (selected) {
                let search = {};
                search[selected] = criteria;

                if (criteria && selected !== 'status'){
                    search[selected] = criteria;
                }else if(status){
                    search[selected] = status
                }
                lastActivePage = meta.value.page;

                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Branch/switch_page', { meta: updatedMeta });

                store.commit('Branch/set_search', {search});
                store.dispatch('Branch/read').then(() => {
            });
            }
        }

        function clearSearch(){
            store.commit('Branch/clear_search');
            store.dispatch('Branch/read').then(() => {});
        }

        function closeWarning() {
             isWarningVisible.value = false;
        }

        return {
            deactivate,
            activate,
            confirmDelete,
            handleDelete,
            closeDeleteConfirm,
            isDeleteConfirmVisible,
            itemToDelete,
            page,
            load_state,
            fields,
            meta,
            navPage,
            branchSearch,
            selectBranch,
            searchBy,
            searchOptions,
            search,
            clearSearch,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            statusOptions,
            isWarningVisible,
            warningMessage,
            closeWarning
        }
    },
    computed:{
        ...mapState({
            branches: state=>state.Branch.branches,
            searchBy: state=>state.OSearch
        }),
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSearch,
        OWarningBox
    }
}
</script>

<style scoped>
    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }

    .btn-deactivate-custom {
        background-color: #ffa726;
        border-color: #ffa726;
        color: #fff;
    }

    .btn-deactivate-custom:hover {
        background-color: #ffb23e;
        border-color: #ffb23e;
        color: #fff;
    }

    .btn-activate-custom {
        background-color: #28a745;
        border-color: #28a745;
        color: #fff;
    }

    .btn-activate-custom:hover {
        background-color: #31ce55;
        border-color: #31ce55;
        color: #fff;
    }

    .blur-row {
        /* filter: blur(1px); */
        opacity: 0.6;
    }

    .status-active {
        color: #28a745; /* Warna hijau */
        font-weight: bold;
    }

    .status-inactive {
        color: #dc3545; /* Warna merah */
        font-weight: bold;
    }
    
</style>